import { useSelector } from 'react-redux';

export function useRecurringTransfer() {
	return useSelector(({ entities }) => entities.recurringTransfer);
}
